import React from "react";
import useAddCategoryPopup from "./useAddCategoryPopup";
import PopupHeader from "../PopupHeader";
import PrimaryButton from "../../Buttons/PrimaryButton";
import TertiaryButton from "../../Buttons/TertiaryButton";
import Input from "../../Input/Input";
import greenCheckmark from "../../../assets/images/checkGreenNoBackground.svg";

const tagTextCN =
  "text-es-green font-es-semibold tracking-es-normal text-es-sm";

const tagCN =
  "rounded-3xl py-2 px-3 flex flex-row items-center gap-1 text-es-green bg-backgroundGreen border border-es-green";
const errorMessage = (isAdminPage) =>
  isAdminPage
    ? "This category is already available"
    : "This category is already active.";
const AddCategoryPopup = ({ popupData, closePopup }) => {
  const {
    confirm,
    value,
    setValue,
    isDisabled,
    isAdminPage,
    adminPreferences,
    selectCategory,
    preferenceList,
  } = useAddCategoryPopup({
    popupData,
    closePopup,
  });

  return (
    <>
      <PopupHeader headerTitle="Add New Category" closePopup={closePopup} />
      <div className="p-5" style={{ width: "500px" }}>
        <div className="m-2">
          <Input
            value={value}
            onChange={(val) => setValue(val)}
            customErrorMessage={isDisabled && errorMessage(isAdminPage)}
            placeholder="Enter New Category"
          />
          <div
            className="flex flex-row flex-wrap p-4 gap-2 overflow-auto mt-2"
            style={{ maxHeight: "250px" }}
          >
            {Object.keys(adminPreferences)?.map((item) => (
              <div className="flex" key={item.id}>
                <button
                  type="button"
                  onClick={() => selectCategory(item)}
                  className={tagCN}
                  disabled={isAdminPage}
                >
                  {preferenceList
                    ?.map((title) => title?.toLowerCase())
                    .includes(item?.toLowerCase()) && (
                    <img
                      src={greenCheckmark}
                      className="flex"
                      style={{ height: "12px", width: "12px" }}
                      alt="selected"
                    />
                  )}
                  <p className={tagTextCN}>{item}</p>
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="flex mt-6 justify-center">
          <PrimaryButton
            title="Save"
            border="primaryGreen"
            onClick={confirm}
            disabled={isDisabled}
          />
          <div className="ml-2">
            <TertiaryButton
              title="Cancel"
              border="primaryGreen"
              onClick={closePopup}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCategoryPopup;
